<template>
  <div>
    <el-tooltip placement="right">
      <div slot="content" class="max-w-sm max-h-500p overflow-auto">
        <span v-safe-html="content" />
      </div>
      <span class="tooltip-icon-html__icon-wrap">
        <base-icon :size="size" name="info" class="w-10/5 h-10/5 cbutton--prim-phantom bg-primary-50 dark:bg-darkblue text-primary hover:text-primary-800 dark:hover:text-white hover:bg-primary-100 dark:hover:bg-primary-500 rounded-full" />
      </span>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'tooltip-icon-html',
  props: {
    content: {
      type: String,
      default: 'info'
    },
    size: {
      type: String,
      default: 'md'
    },
  },
}
</script>
